var path = 'js/components/print-design/print-design.template.html';
var html = "<div class=modal-header> <h4 class=modal-title>Print your design</h4> </div> <div class=modal-body ng-if=!$ctrl.pdf> <p>Generating PDF.</p> </div> <div class=modal-body ng-if=$ctrl.pdf> <p>Your design is ready to be downloaded.</p> </div> <div class=modal-footer ng-if=$ctrl.pdf> <a ng-href={{$ctrl.pdf.url}} class=\"btn btn-primary\" target=_blank>Download</a> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/print-design/print-design.template.html
// module id = 155
// module chunks = 0